// vendor modules
import styled from 'styled-components'

export const LogoWrapper = styled.div`
  position: absolute;
  top: -60px;
  left: 0;
`
